enum ComponentTypes {
  CMSButton = "SchaefflerButtonComponent",
  CMSList = "SchaefflerListComponent",
  CMSParagraph = "CMSParagraphComponent",
  CMSSection = "SchaefflerMainPageComponent",
  CMSLink = "CMSLink",
  CMSColumnLink = "SchaefflerLinkComponent",
  CMSColumnLinks = "SchaefflerLinksComponent",
  CMSPageNavigation = "SchaefflerInPageNavigationComponent",
  CMSTeaserContainer = "SchaefflerTeaserContainerComponent",
  CMSTeaser = "SchaefflerTeaserComponent",
  CMSPublicationTeaser = "SchaefflerTeaserPublicationComponent",
  CMSBanner = "SchaefflerBannerComponent",
  CMSRotatingBanners = "SchaefflerRotatingBannersComponent",
  CMSStandaloneMedia = "SchaefflerStandaloneMediaComponent",
  CMSFilterableTileContainer = "SchaefflerFilterableTileContainerComponent",
  CMSLoginCall = "SchaefflerLoginCallComponent",
  CMSQuote = "SchaefflerQuoteComponent",
  CMSColumnsContainer = "SchaefflerColumnsContainerComponent",
  CMSColumn = "SchaefflerColumnComponent",
  CMSNewsLetterConsent = "SchaefflerNewsletterConsentComponent",
  CMSPhotoGallery = "SchaefflerPhotoGalleryComponent",
  CMSPhoto = "SchaefflerImageComponent",
  CMSAccordionContainer = "SchaefflerAccordionContainerComponent",
  CMSAccordion = "SchaefflerAccordionComponent",
  CMSTable = "SchaefflerTableComponent",
  EwellixPageNavigation = "SchaefflerEwellixInPageNavigationContainerComponent",
  Form = "SchaefflerForm",
  FormHiddenField = "SchaefflerFormHiddenFieldConfiguration",
  FormFieldSelect = "SchaefflerFormOptionsFieldConfiguration",
  FormFieldText = "SchaefflerFormTextFieldConfiguration",
  FormFieldCheckbox = "SchaefflerFormCheckboxFieldConfiguration",
  CMSCardComponent = "SchaefflerCardComponent",
  CMSHomepagePersonalization = "SchaefflerHomepagePersonalizationComponent",
  CMSChipLink = "SchaefflerChipsLinkComponent",
  CMSHomepagePersonalizationRecent = "SchaefflerHomepagePersonalizationRecentComponent",
  CMSChipList = "SchaefflerHomepageChipListComponent",
  CMSKameleoonSlot = "SchaefflerKameleoonSlotComponent",
}

export default ComponentTypes;
